import React, { useState } from 'react';
import moment from 'moment';

import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons/faFilter';

const fmtDate = (d) => (d ? moment(d).format('YYYY.MM.DD') : '');

const DayRangeRangePicker = ({
  value,
  placeholder = 'Pick a date',
  onChange = () => {},
  className = '',
}) => {
  const { from, to } = value || {};
  const [show, setShow] = useState(false);
  const [selecting, setSelecting] = useState(null);

  return (
    <span className={`position-relative ${className}`}>
      <div className="btn-group bg-white">
        <span className="input-group-text bg-white">
          <FA icon={faFilter} />
        </span>
        <button className="btn border" onClick={() => setShow(!show)}>
          {!value && !selecting ? placeholder : (
            <>
              {fmtDate(selecting || from)} - {fmtDate(selecting ? '' : to)}
            </>
          )}
        </button>
        {value && (
          <button
            className="btn border"
            onClick={() => {
              setShow(false);
              onChange(null);
            }}
          >
            &times;
          </button>
        )}
      </div>
      {show && (
        <div
          className={`
            position-absolute bg-white
            border
            mt-2 pt-3 px-3
          `}
          style={{ zIndex: 100, right: 0 }}
        >
          <DayPicker
            className="Selectable"
            initialMonth={
              to || new Date()
            }
            selectedDays={
              selecting ? [selecting] : [from, { from, to }]
            }
            modifiers={{
              start: selecting || from,
              end: selecting ? undefined : to,
            }}
            onDayClick={(date) => {
              const d = moment(date).startOf('d').toDate();

              if (selecting) {
                const [f, t] = [selecting, d].sort((a, b) => a - b);

                setSelecting(null);
                setShow(false);
                onChange({ from: f, to: t });
              } else {
                setSelecting(d);
              }
            }}
          />
        </div>
      )}
    </span>
  );
};

export default DayRangeRangePicker;
